import { AppState } from '@/context/appContext';
import { addObjectToAppState, renderOrderToZindexMap } from '@/functions/renderOrderFunctions';

export enum RenderOrderReducerActionType {
  BRING_TO_TOP = 'BRING_TO_TOP',
  ADD_OBJECT = 'ADD_OBJECT',
  DELETE_OBJECT = 'DELETE_OBJECT',
}

export type RenderOrderReducerAction = {
  type: RenderOrderReducerActionType;
  payload: { id: string };
};

const renderOrderReducer = (appState: AppState, action: RenderOrderReducerAction) => {
  const { id } = action.payload;

  switch (action.type) {
    case RenderOrderReducerActionType.ADD_OBJECT: {
      return addObjectToAppState(appState, id);
    }
    case RenderOrderReducerActionType.DELETE_OBJECT: {
      const updatedOrder = appState.pdfObjectsRenderOrder.filter((elId) => elId !== id);

      return {
        ...appState,
        pdfObjectsRenderOrder: updatedOrder,
        pdfOBjectsZIndexMap: renderOrderToZindexMap(updatedOrder),
      };
    }
    case RenderOrderReducerActionType.BRING_TO_TOP: {
      const updatedOrder = [...appState.pdfObjectsRenderOrder.filter((elId) => elId !== id), id];

      return {
        ...appState,
        pdfObjectsRenderOrder: updatedOrder,
        pdfOBjectsZIndexMap: renderOrderToZindexMap(updatedOrder),
      };
    }
    default:
      return appState;
  }
};

export default renderOrderReducer;
